/**
 * Angular imports.
 */
import { Component, OnInit } from '@angular/core';

/**
 * Service imports.
 */
import { FunCollectionService } from '../common/common-functions/fun-collection.service';
import { DataStorageService } from '../dataservices/data-storage.service';

/**
 * Web Component
 */
@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss']
})
export class WebComponent implements OnInit {
  public deviceType: string;
  public nudge_offset = 1;
  public nudge_action_type = 'action';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public nudge_data: any;

  /**
   * Necessary instances
   */
  constructor(
    public dss: DataStorageService,
    public fcs: FunCollectionService) {
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.dss.global_selected_filter = 0;
    this.dss.search_keyword = '';
    this.dss.clinicalReskey = '';
    this.dss.clinicalLabel = '';
  }
}
